export default __webpack_public_path__ + "static/media/warning--triple-lanes-left-turn--g1.8bf1c712.png";